// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Popover from "@insite/mobius/Popover";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import Link from "@store/MobiusOverrides/Link/Link";
import { menuSecondaryNavigationItemStyles } from "@store/Themes/common/mixins/menu";
import { transitionHoverStyles } from "@store/Themes/common/mixins/transition";
import CanadaCountryIcon from "@store/Library/Components/CountryIcons/CanadaCountryIcon";
import USACountryIcon from "@store/Library/Components/CountryIcons/USACountryIcon";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React, { FC, useRef, useState } from "react";
import { css } from "styled-components";

export interface CountrySelectorStyles {
    countrySelectorWrapper?: InjectableCss;
    countrySelectorLinkButton?: InjectableCss;
    countrySelectorMenu?: InjectableCss;
}

export const CountrySelectorStyles: CountrySelectorStyles = {
    countrySelectorWrapper: {
        css: css`
            ${menuSecondaryNavigationItemStyles()}
            display: flex;
            align-items: center;
            margin-left: ${pxToRem(-8)};

            &:hover {
                color: ${getColor("menu.secondaryNavigation.hover")};
                text-decoration: underline;
                transition: ${transitionHoverStyles()};
            }
        `,
    },
    countrySelectorLinkButton: {
        css: css`
            display: flex;
            align-items: center;

            > span {
                display: flex;
                padding: ${pxToRem(8)};
            }
        `,
    },
    countrySelectorMenu: {
        css: css`
            width: ${pxToRem(80)};
            padding: ${pxToRem(4, 6)};
            text-align: center;
        `,
    },
};

type Props = WidgetProps;
export const CountrySelector: FC<Props> = () => {
    const styles = CountrySelectorStyles;
    const popoverRef = useRef<HTMLUListElement>(null);
    const popoverBodyRef = useRef<HTMLUListElement>(null);

    return (
        <StyledWrapper {...styles.countrySelectorWrapper}>
            <Popover
                controlsId="countrySelectorMenu"
                contentBodyProps={{ ref: popoverBodyRef }}
                ref={popoverRef}
                insideRefs={[popoverBodyRef]}
                popoverTrigger={
                    <Link {...styles.countrySelectorLinkButton}>
                        <CanadaCountryIcon />
                    </Link>
                }
            >
                <StyledWrapper {...styles.countrySelectorMenu}>
                    <USACountryIcon />
                </StyledWrapper>
            </Popover>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: CountrySelector,
    definition: {
        displayName: "Country Selector",
        icon: "language",
        group: "Common",
    },
};

export default widgetModule;
